import React from 'react'
import Layout from '../Layout/Layout'

const Sustainable_Energy = () => {
  return (
    <Layout>
        <div className='uk-container '>
          <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                 <p className='light uk-margin-xlarge-top'>At the centre of Africa’s decarbonisation efforts 
                    is the challenge of how to power society. Transport, housing, and
                     industry all require sustainable energy sources.</p>

                     <p className='light'>
                         Renewable energy
                      now offers a cheaper, more efficient and life-changing alternative.
                     </p>
               </div>

                   <div className='uk-width-1-2@s'>
                       <h4 className='light  uk-margin-xlarge-top'>Moolu Venture Lab can help you through:</h4>

                       <p className='light'>Entrepreneurial education – Develop a skills-building programme in clean energy and 
                        energy system design, while developing the skills and business knowledge needed to
                         test innovative solutions.</p>

                            <p className='light'>Innovation-driven research – test and refine breakthrough clean energy ideas and commercialise research results..</p>

                            <p className='light'>Business creation and acceleration – secure resources to establish
                                 new companies and build long-term networks across the clean energy sector. Connect 
                                 with experts and investors who offer mentoring, support and investment.</p>
               </div>
          </div>
        </div>

        </Layout>
  )
}

export default Sustainable_Energy